import { Register } from './Register';

export type { TypeRegisterProps } from './types';
export default Register;
